import { render, staticRenderFns } from "./extratoFeriasServidor.vue?vue&type=template&id=6aaf628c&scoped=true&"
import script from "./extratoFeriasServidor.vue?vue&type=script&lang=js&"
export * from "./extratoFeriasServidor.vue?vue&type=script&lang=js&"
import style0 from "./extratoFeriasServidor.vue?vue&type=style&index=0&id=6aaf628c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaf628c",
  null
  
)

export default component.exports